import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { useAuth } from '../context/auth';
import { IMAGE_COUNT_QUERY, USER_METRICS_QUERY } from '../graphql/queries';

export function useBodyDataAttributes() {
  const { user, profile } = useAuth();

  const { data: imagesData } = useQuery(IMAGE_COUNT_QUERY, {
    skip: !user,
  });

  const { data: userData } = useQuery(USER_METRICS_QUERY, {
    skip: !user,
    variables: { asfId: user?.user_id },
    fetchPolicy: 'network-only',
    pollInterval: 60000, // Poll every 60 seconds
  });

  useEffect(() => {
    if (!user || !profile) {
      document.body.removeAttribute('data-days-since-acct-created');
      document.body.removeAttribute('data-images-uploaded-count');
      document.body.removeAttribute('data-mockups-downloaded');
      document.body.removeAttribute('data-social-post-success-count');
      document.body.removeAttribute('data-have-phone-number');
      document.body.removeAttribute('data-chat-messages-sent');
      document.body.removeAttribute('data-sparks-ran');
      return;
    }

    const daysSinceCreated = Math.floor((Date.now() - new Date(profile.createdAt).getTime()) / (1000 * 60 * 60 * 24));
    const imagesCount = imagesData?.imageStats?.count || 0;
    const mockupsDownloaded = profile.profile?.hasMockupDownloads || false;
    const socialPostCount = userData?.user?.numSocialPosts || 0;
    const hasPhone = !!profile.profile?.phoneNumber;
    const chatMessages = userData?.user?.numChatMessages || 0;
    const sparksRan = userData?.user?.numSparksRan || 0;

    document.body.setAttribute('data-days-since-acct-created', String(daysSinceCreated));
    document.body.setAttribute('data-images-uploaded-count', String(imagesCount));
    document.body.setAttribute('data-mockups-downloaded', String(mockupsDownloaded));
    document.body.setAttribute('data-social-post-success-count', String(socialPostCount));
    document.body.setAttribute('data-have-phone-number', String(hasPhone));
    document.body.setAttribute('data-chat-messages-sent', String(chatMessages));
    document.body.setAttribute('data-sparks-ran', String(sparksRan));
  }, [user, profile, imagesData, userData]);
}
